import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import * as Sentry from '@sentry/react';

const KTP_SERVER =
  // @ts-ignore
  import.meta.env.MODE === 'development'
    ? 'http://123.142.246.11:50921'
    : 'https://admin.ktaxpay.com';

export const axiosRequestConfiguration: AxiosRequestConfig = {
  baseURL: KTP_SERVER,
  responseType: 'json',
  headers: {
    Authorization: 'successmode806',
  },
};

export const axiosInstance = axios.create(axiosRequestConfiguration);

axiosInstance.interceptors.response.use(
  (res: AxiosResponse) => {
    return res;
  },
  async (error: AxiosError) => {
    const code = error?.response?.data.code;
    switch (code) {
      case 'Unknown': {
        alert(
          'An unknown error occurred. Please refresh and try again in a few minutes.',
        );
        break;
      }
      case undefined: {
        alert(
          'The network condition is unstable. Please refresh and try again in a few minutes.',
        );
        break;
      }
      default: {
        break;
      }
    }
    Sentry.withScope((scope) => {
      scope.setExtra('status', error?.response?.status);
      scope.setExtra('response', error?.response?.data);
      scope.setExtra('url', error.config?.url);
      scope.setExtra('method', error.config?.method);
      scope.setExtra('baseURL', error.config?.baseURL);
      scope.setExtra('data', error.config?.data);
      scope.setExtra('headers', error.config?.headers);
      Sentry.captureException(error);
    });
    return Promise.reject(error?.response);
  },
);
